(function (ng, app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Contacts",
                    {
                        url: "/Contacts",
                        redirectTo: "Home.Tools.MarketingTrackerNew.Contacts.ContactList",
                        component: "contacts"
                    });
        }
    ]);

    app
        .component("contacts",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Contacts/contacts-template.html",
                controller: contactsController
            });

    contactsController.$inject = ['featureToggleService'];
    function contactsController(featureToggleService) {
        const $ctrl = this;

        $ctrl.$onInit = function () {
            $ctrl.toggleFeature = featureToggleService.checkEnv();
        };
    }

})(window.angular, window.app); //jshint ignore:line